// extracted by mini-css-extract-plugin
export var container = "section-slider-module--container--zVG8a";
export var nextIcon = "section-slider-module--next-icon--HE4D0";
export var prevIcon = "section-slider-module--prev-icon--90B8s";
export var swiperContainer = "section-slider-module--swiper-container--VWYRu";